export enum TipoEstadoCivil
{
    Soltero = "Soltero",
    Casado = "Casado",
    Viudo = "Viudo",
    SeparadoDivorciado = "Separado/Divorciado",
    ConvivienteCivil = "Conviviente Civil",
}